import { Component, OnInit, Input } from '@angular/core';
import { PerformanceCard } from '../types/card.types';
const HIKE_CLASS = {
  NEGATIVE: 'text-right text-red',
  POSITIVE:  'text-right text-green',
};

@Component({
  selector: 'app-fraud-card',
  templateUrl: './fraud-card.component.html',
  styleUrls: ['./fraud-card.component.css']
})
export class FraudCardComponent implements OnInit {

  @Input() card: PerformanceCard;
  hikeClass: string;
  cardStyle: any;
  constructor() { }

  ngOnInit() {
    this.hikeClass = this.card.isPositivehike ? HIKE_CLASS.POSITIVE : HIKE_CLASS.NEGATIVE;
  }

}
